// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"358094a3","375":"3d66e8c6"}[chunkId] + ".chunk.js";
};